import { render, staticRenderFns } from "./mi-cuenta-corriente.vue?vue&type=template&id=18041a18&scoped=true"
import script from "./mi-cuenta-corriente.vue?vue&type=script&lang=js"
export * from "./mi-cuenta-corriente.vue?vue&type=script&lang=js"
import style0 from "./mi-cuenta-corriente.vue?vue&type=style&index=0&id=18041a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18041a18",
  null
  
)

export default component.exports